// Configure which academic years are shown in year selectors.
// To add a new year, copy an existing folder and content file first.
// Example for พ.ศ. 2570:
// 1. Copy src/years/2569 to src/years/2570
// 2. Make sure src/years/2570/content.js exists
// 3. Change latestBeYear below to 2570
export const academicYearDisplayRange = {
  latestBeYear: 2569,
  earliestBeYear: 2563,
};
